<template>
  <div class="form" style="text-align:left;">
    <div class="title is-4">{{title}}</div>



    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Name">
          <b-input maxlength="255" v-model="item.name"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Email">
          <b-input maxlength="255" v-model="item.email"></b-input>
        </b-field>
      </div>
    </div>


    <div class="title is-5">Konfiguration</div>
    <div v-for="(config, index) in item.whitelabelPartnerConfigurations" class="columns" style="margin-bottom: 0">
      <div class="column" style="text-align:left; padding-bottom: 0px;">
        <b-field label="Key">
          <b-input maxlength="255" v-model="item.whitelabelPartnerConfigurations[index].key"></b-input>
        </b-field>
      </div>
      <div class="column" style="text-align:left; padding-bottom: 0px;position:relative;">
        <b-field label="Property">
          <b-input maxlength="3000" type="textarea" v-model="item.whitelabelPartnerConfigurations[index].property"></b-input>
        </b-field>
        <div style="position: absolute; right: -20px; top: 48px;">
          <button style="border:0px;" class="button is-small" @click="deleteConfig(item.whitelabelPartnerConfigurations[index].id, index)">
            <b-icon type="is-danger" icon="delete"></b-icon>
         </button>
        </div>
      </div>
    </div>
    <div class="columns" style="    margin-top: -28px;">
      <div class="column" style="text-align:left;">
        <b-button class="button is-small is-white" @click="addConfig">
          <b-icon custom-size="mdi-18px" type="is-black" icon="plus-circle"></b-icon>
          <span style="position: relative;left: 2px;top: -2px;">Konfiguration hinzufügen</span>
        </b-button>
      </div>
    </div>

    <div class="columns" style="margin-top:20px;">
      <div class="column" style="text-align:right;">
        <b-button type="is-primary" v-on:click="save()" :disabled="loading">Speichern</b-button>
      </div>
    </div>

  </div>
</template>


<script>
// @ is an alias to /src


import Vue from 'vue'

const axios = require('axios');


export default {
  name: "home",
  components: {

},
data() {
      return {
          title: "Neuen Whitelabel-Partner anlegen",
          item: {},
          loading: true
        //  item: { 'id': 22, 'name': 'Beidseitig individuelles Kartenset', 'spielart': 'Kartenspiel', 'date': '2016-10-15 13:43:27' },
      }
  },
  watch: {

  },
  mounted: function() {
    console.log("FORM "+ this.$route.params.id);
    if (this.$route.params.id) {
      this.title = "Whitelabel-Partner bearbeiten";
      //Get-Config
      this.loadConfig();
    } else {
      this.loading = false;
      this.item = {
        name: "",
        email: "",
        whitelabelPartnerConfigurations: []
      };
    }

  },
  methods: {
    loadConfig: function() {
      var _this = this;
      axios.get('/api/whitelablepartner/'+this.$route.params.id, {
        withCredentials: true,
      })
      .then(function (response) {
        console.log(response.data);
        _this.item = response.data;
        _this.loading = false;

      })
      .catch(function (error) {
        console.log(error);
      })
      .then(function () {
        // always executed
      });
    },
    deleteConfig: function(configid, index) {
      console.log("deleteConfig "+configid);
      if (configid) {
        var vm = this;
        this.$buefy.dialog.confirm({
          title: 'Konfiguration löscen',
          message: 'Soll die Konfiguration wirklich gelöscht werden?',
          confirmText: 'Konfiguration löschen',
          type: 'is-danger',
          hasIcon: true,
          cancelText: 'Abbrechen',
          onConfirm: function() {
            console.log(vm.search);
            axios.delete('/api/whitelablepartner/'+vm.item.id+'/whitelabelPartnerConfigurations/'+configid, {
            withCredentials: true,
            })
            .then(function (response) {
              console.log(response.data);
               vm.$buefy.toast.open('Die Konfiguration wurde gelöscht!');
               //vm.loadConfig();
               vm.item.whitelabelPartnerConfigurations.splice(index, 1);
            })
            .catch(function (error) {

            })
            .then(function () {
              // always executed
            });

           }
         })
      } else {
        this.item.whitelabelPartnerConfigurations.splice(index, 1);
      }
    },
    addConfig: function() {
      console.log("addconfig");
      var configObj = {
          key: "",
          property: ""
      };
      this.item.whitelabelPartnerConfigurations.push(configObj);

    },
    save: function() {
      if ((this.item.name) && (this.item.email)){

        //Set-Package
        var _this = this;
        var url = '/api/whitelablepartner';


        console.log("SAVE");
        console.log(url);
        console.log(this.item);

        axios.post(url, this.item, {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        })
        .then(function (response) {
          console.log(response.data);
          _this.$router.push({ name: 'whitelabel' })
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
        });

      } else {
        console.log("Alle Felder ausfüllen");
        this.$buefy.dialog.alert({
                      title: 'Fehler',
                      message: 'Bitte füllen Sie alle Felder aus.',
                      type: 'is-danger',
                      hasIcon: true,
                      icon: 'alert-circle',
                      iconPack: 'mdi'
                  });

    }

    }
  }
};

</script>
